<div class="container">
    <div class="firm-info">
        <div class="firm-info__logo">
            <img src="../../../../assets/img/logo-sinclair-prosser.png" class="img-responsive">
        </div>
        <div class="firm-info__text">
            <p>
                183 Truman Parkway<br>
                Suite 104<br>
                Annapolis, MD 21401<br>
                (410) 573-4818<br>
                <a href="mailto:info@spgasior.com" class="firm-info__link">info@spgasior.com</a><br>
                <a href="https://spgasior.com/" target="_blank" class="firm-info__link">https://spgasior.com/</a>
            </p>
        </div>
    </div>

</div>